module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-alert"
  }, [_c('x-dialog', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showValue),
      expression: "showValue"
    }],
    staticClass: "weui_dialog_alert",
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition
    },
    domProps: {
      "value": (_vm.showValue)
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      },
      "input": function($event) {
        _vm.showValue = $event
      }
    }
  }, [_c('div', {
    staticClass: "weui_dialog_hd"
  }, [_c('strong', {
    staticClass: "weui_dialog_title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui_dialog_bd"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "weui_dialog_ft"
  }, [_c('a', {
    staticClass: "weui_btn_dialog primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onHide
    }
  }, [_vm._v(_vm._s(_vm.buttonText || _vm.$t('button_text')))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-355e02bd!./~/.1.0.35@vux-loader/src/template-loader.js!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./~/.2.0.17@vux/src/components/alert/index.vue
// module id = 277
// module chunks = 2